export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const BASE_PATH = [
  'contact', 'cta', 0, 'contactSection', 'content', 0, 'headerSection',
] as const;